module.exports = __webpack_public_path__ + "img/GOgreen.46eab31f.png";